import { Injectable } from '@angular/core';
import { Config } from 'ionic-angular';

@Injectable()
export class GlobalAdCounter {
  public addCount:number = -1;
}


// WEBPACK FOOTER //
// ./src/providers/global-ad-counter.ts